import { TaboolaFeedWidget } from './taboolaFeedWidget.jsx';

const props = [
    'height',
    'width',
    'position'
];

export const TaboolaFeedWidgetDirective = reactDirective => reactDirective(TaboolaFeedWidget, props);
TaboolaFeedWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('taboolaFeedWidget', TaboolaFeedWidgetDirective);
